import type { ReactNode } from 'react';

import AddDocuments from './steps/AddDocuments';
import Intro from './steps/Intro';
import Narrative from './steps/Narrative';
import SelectAssets from './steps/SelectAssets';
import Summary from './steps/Summary';

interface StepConfig {
  title: ReactNode;
  content: () => JSX.Element;
}

export const DOCUMENT_STEP = 2;

export const stepConfig: { [key: number]: StepConfig } = {
  0: {
    title: 'Request Data',
    content: Intro,
  },
  1: {
    title: 'Select Agencies and Record Types for Request',
    content: SelectAssets,
  },
  2: {
    title: 'Additional Info',
    content: AddDocuments,
  },
  3: {
    title: 'Confirm Project Narrative & Location',
    content: Narrative,
  },
  4: {
    title: 'Summary',
    content: Summary,
  },
};
